
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/assets",
      function () {
        return require("private-next-pages/assets/index.nemo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/assets"])
      });
    }
  